import { env } from "@/config/environment-vars";
import { HeaderLogo } from "@cmde/shadcn";

export const APP_LOGO_LIGHT = `${import.meta.env.BASE_URL}logos/logo-positive.svg`;
export const APP_LOGO_DARK = `${import.meta.env.BASE_URL}logos/logo-negative.svg`;

type AppBrandLogoProps = {
  theme: string;
  className?: string;
};

export const AppBrandLogo = ({ theme, className }: AppBrandLogoProps) => (
  <HeaderLogo
    projectTitle={env.VITE_PROJECT_TITLE}
    logoSrc={APP_LOGO_LIGHT}
    logoSrcDark={APP_LOGO_DARK}
    theme={theme}
    className={className}
  />
);
